export default {
  FORMAT_DATE: 'YYYY-MM-DD',
  FORMAT_TIME: 'hh:mm:ss',
  FORMAT_TIME_HOUR: 'HH',
  FORMAT_DATETIME: 'YYYY-MM-DD hh:mm:ss'
}